<template>
	<div class="Home">
	  <div class="login-outer-div">
		<Login />
	  </div>
	  <!-- <request-demo /> -->
	  <!-- <footerbar /> -->
	</div>
  </template>
  <script>
  import Login from '../../components/Login/Login.vue'
  export default {
	name: "Home",
	components: {
		Login
	},
	mixins: [],
	props: [],
	data() {
	  return {};
	},
	computed: {
	  showLoginModel() {
		// Whenever $store.state.show_login_and_freeTrial_model changes, it will cause the computed property to re-evaluate, and trigger associated DOM updates.
		return this.$store.state.show_login_and_freeTrial_model;
	  },
	},
	methods: {
	  goToFreeTrial() {
		this.$store.commit("showFreeTrialModel", true);
		this.$store.commit("openLoginModel", true);
		// this.$router.push("/user-registration/start-free-trial-and-login");
	  },
	  redirectToTargetPage(page_name) {
		this.$router.push({ path: page_name });
	  },
	},
  };
  </script>
  <style lang="scss">
  button:focus {
	outline: none;
  }
  </style>
  <style lang="scss" scoped>
  @import "../../assets/css/variable.scss";
  @import "./HomePage.scss";
  @import "./HomePageM.scss";
  </style>
  
  <style>
  /******** homepage main carousel *********/
  .Home .c .el-carousel__container {
	height: 600px;
  }
  
  @media screen and (max-width: 576px) {
	.Home .c .el-carousel__container {
	  height: 450px;
	}
  }
  
  .Home .VueCarousel-inner {
	/* padding: 0 40px; */
	margin-top: 40px;
  }
  </style>
  